<template lang="pug">
Auth(@loggedIn="onLoggedIn" :redirectWithLoginFailed="true")
  div.wrap-studio
    ModuleStudio(ref="moduleStudio"
      v-if="assets && frame && tutorial !== null"
      :assets="assets" :frame="frame"
      :tutorial="tutorial")
</template>

<!-- <style lang="scss" scoped>
@import "@/scss/_variables.scss";
.wrap-studio {
}
</style> -->

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/shared/Auth'
import Header from '@/components/shared/Header'
import ModuleStudio from '@/components/module/studio/ModuleStudio'

export default {
  components: {
    Auth,
    Header,
    ModuleStudio
  },
  data () {
    return {
      assets: null,
      // objects: [],
      frame: null,
      episode: null,
      tutorial: null
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  async created () {
    await this.sleep(200)
    
    const rp = this.$route.params

    // database.assetCollection()
    //   .getImportedAssetsInRealtime(rp.frameId, this.updateAssets)
    // database.objectCollection(rp.comicId, rp.episodeId, rp.pageId, rp.frameId)
    //   .getObjectsInRealtime(this.updateObjects)

    // database.frameCollection(rp.comicId, rp.episodeId, rp.pageId)
    //   .findByIdWithSnapshot(rp.frameId, this.updateFrame)

    this.frame = await database
      .frameCollection(rp.comicId, rp.episodeId, rp.pageId)
      .findById(rp.frameId)
    
    const types = this.assetTypes.map(e => e.type)
    const assetIds = types
      .map(t => this.frame.assetOrder[t] ? this.frame.assetOrder[t] : []).flat()
    this.assets = await database.assetCollection().getAssetsByIds(assetIds)

    this.episode = await database
      .episodeCollection(rp.comicId)
      .findById(rp.episodeId)
  },
  mounted () {
    this.$root.$on('updateImportedAssetsAfterAddingNewAsset', this.updateImportedAssetsAfterAddingNewAsset)
    this.$root.$on('deleteAssetFromAssets', this.deleteAssetFromAssets)
  },
  methods: {
    // assets frame episodeのdata更新
    updateImportedAssetsAfterAddingNewAsset ({ frame, newAsset }) {
      if (this.assets.map(a => a.id).includes(newAsset.id)) return

      // console.log('frame:', frame)
      // console.log('newAsset:', newAsset)
      if (frame) this.frame = frame
      if (newAsset) this.assets.unshift(newAsset)
      // if (newAsset) this.assets.push(newAsset)

      // episodeに追加されていないアセットだった場合は追加
      // if (!this.episode.assets || !this.episode.assets.includes(newAsset.id)) {
      //   console.log('add new asset to ep:', newAsset.id)
      //   const rp = this.$route.params
      //   database
      //     .episodeCollection(rp.comicId)
      //     .arrayUnion(rp.episodeId, 'assets', [newAsset.id])
      //   if (this.episode.assets) {
      //     this.episode.assets.push(newAsset.id)
      //   } else {
      //     this.episode.assets = [newAsset.id]
      //   }
      // }

      if (this.episode.asset) {
        if (this.episode.asset[newAsset.type]) {
          this.episode.asset[newAsset.type].unshift(newAsset.id)
        } else {
          this.episode.asset[newAsset.type] = [newAsset.id]
        }
      } else {
        let asset = {}
        asset[newAsset.type] = [newAsset.id]
        this.episode.asset = asset
      }
    },
    deleteAssetFromAssets ({ asset }) {
      const moduleStudio = this.$refs.moduleStudio
      if (moduleStudio && moduleStudio.deleteObjectsOfAsset) {
        moduleStudio.deleteObjectsOfAsset({ assetId: asset.id })

        this.assets = this.assets.filter(a => a.id !== asset.id)
        const rp = this.$route.params
        this.frame.assetOrder[asset.type] = this.frame.assetOrder[asset.type]
          .filter(assetId => asset.id !== assetId)
        database
          .frameCollection(rp.comicId, rp.episodeId, rp.pageId)
          .update(rp.frameId, { assetOrder: this.frame.assetOrder })
      }
    },
    onLoggedIn () {
      database.userTutorialCollection(this.uid)
        .findByIdWithSnapshot('studio', this.updateTutorial)
    },
    updateTutorial (doc) {
      this.tutorial = doc.data()
    }
    // updateAssets (q) {
    //   this.assets = q.docs.map(d => {
    //     return { id: d.id, objectID: d.id , ...d.data() }
    //   })
    //   console.log('this.assets:', this.assets)
    // },
    // updateObjects (q) {
    //   this.objects = q.docs.map(d => {
    //     return { id: d.id, objectID: d.id , ...d.data() }
    //   })
    //   console.log('this.objects:', this.objects)
    // },
    // updateFrame (d) {
    //   this.frame = d.data()
    // }
  },
}
</script>
